var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopics = function SvgTopics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 15,
    x: 0.5,
    y: 5.5,
    stroke: "#fff",
    strokeLinejoin: "round",
    rx: 0.5,
    transform: "rotate(-90 .5 5.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 15,
    x: 0.5,
    y: 15.5,
    stroke: "#fff",
    strokeLinejoin: "round",
    rx: 0.5,
    transform: "rotate(-90 .5 15.5)"
  })));
};
export { SvgTopics as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiPjxyZWN0IHg9Ii41IiB5PSI1LjUiIHdpZHRoPSI1IiBoZWlnaHQ9IjE1IiByeD0iLjUiIHRyYW5zZm9ybT0icm90YXRlKC05MCAuNSA1LjUpIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cmVjdCB4PSIuNSIgeT0iMTUuNSIgd2lkdGg9IjUiIGhlaWdodD0iMTUiIHJ4PSIuNSIgdHJhbnNmb3JtPSJyb3RhdGUoLTkwIC41IDE1LjUpIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4K";